module.exports = __webpack_public_path__ + "static/banner-insights-078c731aa070b656eb9246540ef5a17b.jpg";